
import { permissions, PermissionName, Role } from "core/permissions/Permissions";
import { useUserContext } from "core/store/UserContext";
import { LmUserClaim } from "core/utils/Constants";

const usePermissions = () => {
    const userInformation = useUserContext();
    
    const hasPermission = (permissionName: PermissionName) => {
        const roles = userInformation?.role;
        const requiredRoles = permissions[permissionName];
        
        if(roles) {
            return requiredRoles.some((role: Role) => roles.includes(Role[role]));
        }
        return false;
    }

    // A Network Run belongs to the country rather than to an Agency, so only a
    // Network Planner may list or create one. That is the headquarters flag the
    // app already reads off the token everywhere else. The claim arrives as the
    // string "true" on the token, so compare case-insensitively as a string.
    const isHeadquarters =
        String(userInformation?.[LmUserClaim] ?? '').toLowerCase() === 'true';

    return { hasPermission, isHeadquarters };
}

export default usePermissions;
